#version 300 es
in vec3 aPos;
in float aSize;
in float aAlpha;
uniform mat4 uView;
uniform mat4 uProjection;
out float vAlpha;
void main() {
  vec4 viewPos = uView * vec4(aPos, 1.0);
  gl_Position = uProjection * viewPos;
  // Scale point size by distance (perspective)
  float dist = -viewPos.z;
  gl_PointSize = aSize * 400.0 / max(dist, 1.0);
  vAlpha = aAlpha;
}
